var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from 'clsx';
import { MenuItem } from '../../../menuItem';
import { Text } from '../../../text';
import { DEFAULT_GET_OPTION_DISABLED, DEFAULT_GET_OPTION_LABEL, DEFAULT_GET_OPTION_SUBTITLE, DEFAULT_GET_OPTION_VALUE, } from '../../dropdown.constants';
var displayName = 'DropdownListItem';
/**
 * DropdownListItem is the default list item component wrapper for the dropdown - it will render a custom
 * label if the user provides an overwrite via the DropdownListItemLabel component
 * @param props All dropdown props
 * @returns
 */
export function DropdownListItem(props) {
    var DropdownListItemLabel = props.DropdownListItemLabel, classes = props.classes, compact = props.compact, _a = props.getOptionDisabled, getOptionDisabled = _a === void 0 ? DEFAULT_GET_OPTION_DISABLED : _a, _b = props.getOptionLabel, getOptionLabel = _b === void 0 ? DEFAULT_GET_OPTION_LABEL : _b, _c = props.getOptionSubtitle, getOptionSubtitle = _c === void 0 ? DEFAULT_GET_OPTION_SUBTITLE : _c, _d = props.getOptionValue, getOptionValue = _d === void 0 ? DEFAULT_GET_OPTION_VALUE : _d, index = props.index, multi = props.multi, onSelected = props.onSelected, option = props.option, selectedIndex = props.selectedIndex, selectedOptionsIds = props.selectedOptionsIds;
    var isSelected = index === selectedIndex;
    var optionValue = getOptionValue(option);
    var selected = (selectedOptionsIds === null || selectedOptionsIds === void 0 ? void 0 : selectedOptionsIds.has(optionValue)) || false;
    var disabled = getOptionDisabled(option) || false;
    var computedDropdownClasses = clsx(classes === null || classes === void 0 ? void 0 : classes.listItemContainer, {
        disabled: disabled,
        hovered: isSelected,
        multi: multi,
        selected: selected,
    });
    return (_jsxs(MenuItem, __assign({ role: "option", classes: {
            root: computedDropdownClasses,
        }, compact: compact, component: "div", tabIndex: -1, "aria-selected": isSelected, disabled: disabled, selected: selected, selectType: multi ? 'multi' : 'single', subtitle: getOptionSubtitle(option), labelNoWrap: true, subtitleNoWrap: true, onClick: function (e) {
            e.stopPropagation();
            e.preventDefault();
            if (!disabled)
                onSelected({ option: option, remove: selected });
        }, "data-hawkins-style": "HawkinsDropdown-listItemContainer selected disabled hovered" }, { children: [DropdownListItemLabel && _jsx(DropdownListItemLabel, __assign({}, props)), !DropdownListItemLabel && (_jsx(Text, __assign({ noWrap: true, className: disabled ? classes.listItemLabelParagraphDisabled : classes.listItemLabelParagraph }, { children: getOptionLabel(option) })))] })));
}
DropdownListItem.displayName = displayName;
